import { createSlice } from '@reduxjs/toolkit';

export interface AuthState {
  authInitialized: boolean;
}

const initialState: AuthState = {
  authInitialized: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthInitialized(state) {
      state.authInitialized = true;
    },
    resetAuthInitialized(state) {
      state.authInitialized = false;
    },
  },
});

export const { setAuthInitialized, resetAuthInitialized } = authSlice.actions;

export const authReducer = authSlice.reducer;

export const selectAuthInitialized = (state: { auth: AuthState }) => state.auth.authInitialized;
